import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { AccountLinkCard } from 'web-ui-components/lib/finance/accounts';

import HomepageBL from './HomepageBL';
import StringConstants from '../../constants/StringConstants';
import { accountHasLimitedRead } from '../../utils/AccountCapabilityUtils';
import NumberUtils from '../../utils/NumberUtils';

export const balanceInPence = (balance) => balance * 10 ** 2;

export const showAvailableBalance = (account, availableBalance) => {
  if (get(account.actionsAvailable, '/account/balance/available', '')) {
    return balanceInPence(availableBalance);
  }
  return '';
};

const getBalance = (account, type) => {
  const balances = account.balances || [];
  const filteredBalances = balances.filter((balance) => balance.type === type);
  if (filteredBalances.length > 0) {
    return filteredBalances[0].amount;
  }
  return null;
};

const getBalanceCurrency = (accountBalances = [], type) => {
  const filteredBalances =
    accountBalances &&
    accountBalances.filter((balance) => balance.type === type);
  if (filteredBalances && filteredBalances.length > 0) {
    return get(filteredBalances[0], 'currency', '');
  }
  return null;
};

export const extractBalances = (account) => ({
  availableBalance: getBalance(account, 'available'),
  currentBalance: getBalance(account, 'current'),
  availableBalanceCurrency: getBalanceCurrency(account.balances, 'available'),
  currentBalanceCurrency: getBalanceCurrency(account.balances, 'current'),
});

class AccountCardHomePageList extends React.Component {
  constructor(props) {
    super(props);
    this.goToAccountDetails = this.goToAccountDetails.bind(this);
  }
  componentWillMount() {
    this.setBalances(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.setBalances(nextProps);
  }

  setBalances() {
    this.setState(extractBalances(this.props.account));
  }
  goToAccountDetails() {
    this.props.goToAccountDetails(this.props.account.id);
  }
  render() {
    const { account } = this.props;
    const {
      currentBalance,
      availableBalance,
      currentBalanceCurrency,
      availableBalanceCurrency,
    } = this.state;
    const accNo = HomepageBL.getAccountDisplayNumber(account);
    const hideAccountBalance = accountHasLimitedRead(account);
    const balanceFmtd = balanceInPence(currentBalance);
    const formatCurrency = (amount, currency) =>
      NumberUtils.appendCurrency('{}', amount, currency);

    const commonProps = {
      accountName: account.accountName,
      isFavourite: false,
      onClick: this.goToAccountDetails,
      productNameOrNickname: account.displayName,
      viewType: 'list',
      id: account.id,
    };

    if (account.type === 'credit_card') {
      return (
        <AccountLinkCard.CreditCard
          {...commonProps}
          balance={
            hideAccountBalance
              ? ''
              : typeof currentBalance === 'number'
              ? balanceFmtd
              : 'unavailable'
          }
          availableBalance={
            !hideAccountBalance && typeof availableBalance === 'number'
              ? showAvailableBalance(account, availableBalance)
              : ''
          }
          cardNumber={accNo}
        />
      );
    } else if (account.product.code === StringConstants.KAPITI_PRODUCT_CODE) {
      return (
        <AccountLinkCard.International
          {...commonProps}
          internationalBalance={
            hideAccountBalance
              ? ''
              : typeof currentBalance === 'number'
              ? formatCurrency(currentBalance, currentBalanceCurrency)
              : 'unavailable'
          }
          availableInternationalBalance={
            !hideAccountBalance && typeof availableBalance === 'number'
              ? formatCurrency(availableBalance, availableBalanceCurrency)
              : ''
          }
          IBAN={account.accountNumber}
        />
      );
    }
    return (
      <AccountLinkCard.BankAccount
        {...commonProps}
        balance={
          hideAccountBalance
            ? ''
            : typeof currentBalance === 'number'
            ? balanceFmtd
            : 'unavailable'
        }
        availableBalance={
          !hideAccountBalance && typeof availableBalance === 'number'
            ? showAvailableBalance(account, availableBalance)
            : ''
        }
        accountNumber={Number(account.accountNumber)}
        sortCode={Number(account.sortCode)}
      />
    );
  }
}
AccountCardHomePageList.propTypes = {
  account: PropTypes.object,
  content: PropTypes.object,
  goToAccountDetails: PropTypes.func,
  index: PropTypes.number,
};

export default AccountCardHomePageList;
